/* Mobile filter drawer — proper ARIA tabs pattern with keyboard navigation.
   Replaces the per-render inline cmdToggleTab function. Idempotent. */
(function () {
  if (window.__npFilterTabsBound) return;
  window.__npFilterTabsBound = true;

  function activate(tab) {
    const tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;
    const tabs = tablist.querySelectorAll('[role="tab"]');
    const panelHost = tablist.parentElement;
    const panels = panelHost.querySelectorAll('[role="tabpanel"]');
    const targetId = tab.getAttribute('aria-controls');

    tabs.forEach(function (t) {
      const isThis = t === tab;
      t.setAttribute('aria-selected', isThis ? 'true' : 'false');
      t.setAttribute('tabindex', isThis ? '0' : '-1');
      t.classList.toggle('cmd-tab--active', isThis);
    });

    panels.forEach(function (p) {
      const isThis = p.id === targetId;
      p.classList.toggle('cmd-panel--active', isThis);
      p.toggleAttribute('hidden', !isThis);
    });
  }

  // NOTE: capture phase + stopPropagation is intentional. Shopify's MenuDrawer.bindEvents
  // (assets/global.js) attaches a close-drawer click handler to every <button> inside the
  // mobile drawer (other than .localization-selector). Without intercepting in capture, a
  // tab click would activate the panel AND close the drawer ~400ms later via
  // closeSubmenu/closeAnimation. Stopping propagation here keeps the drawer open.
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.cmd-tab[role="tab"]');
    if (!tab) return;
    e.stopPropagation();
    activate(tab);
  }, true);

  document.addEventListener('keydown', function (e) {
    const tab = e.target.closest('.cmd-tab[role="tab"]');
    if (!tab) return;
    const tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;
    const tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    const i = tabs.indexOf(tab);
    let next = null;
    if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) {
      e.preventDefault();
      activate(next);
      next.focus();
    }
  });
})();
